<template>
  <v-app>
    <div class="app-main-container">
      <DevNavigation v-if="isDevMode" />
      <template v-if="isLoginPage">
        <router-view />
      </template>
      <template v-else>
        <place-reservation v-if="!getQueryPage"></place-reservation>
        <checkout v-if="getQueryPage === 'checkout'"></checkout>
        <payment v-if="getQueryPage === 'payment'"></payment>
        <payment-va v-if="getQueryPage === 'payment-va'"></payment-va>
        <payment-ewallet v-if="getQueryPage === 'payment-ewallet'"></payment-ewallet>
        <payment-qris v-if="getQueryPage === 'payment-qris'"></payment-qris>
        <order-detail v-if="getQueryPage === 'order-detail'"></order-detail>
      </template>
    </div>
  </v-app>
</template>

<script>
import './registerServiceWorker'
// import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { mapGetters } from "vuex"
import './plugins/axios'
import './plugins/vue-phone-number-input'
import './plugins/vee-validate'
import './plugins/vue-socket'
import './plugins/VueTimepicker'
import './plugins/vue-the-mask'
import PlaceReservation from '@/web-component/PlaceReservation.vue'
import Checkout from '@/web-component/Checkout.vue'
import Payment from '@/web-component/Payment.vue'
import PaymentEwallet from '@/web-component/PaymentEwallet.vue'
import PaymentQris from '@/web-component/PaymentQris.vue'
import PaymentVa from '@/web-component/PaymentVa.vue'
import OrderDetail from '@/web-component/OrderDetail.vue'
import DevNavigation from '@/components/DevNavigation.vue'
import { customerData } from "@/api/auth";
import { popStateHandler } from '@/utils/customQuery'
import Cookies from 'js-cookie'
import i18n from './plugins/i18n'

export default {
  name: 'App',
  // router,
  i18n,
  store,
  vuetify,
  components: {
    PlaceReservation,
    Checkout,
    Payment,
    PaymentEwallet,
    PaymentQris,
    PaymentVa,
    OrderDetail,
    DevNavigation
  },
  props: {
    store: {
      type: String,
      default: ''
    },
    url_id: {
      type: String,
      default: process.env.VUE_APP_RESERVATION === 'development' ? 'jakartatest' : '' // jakartatest, allinolsera2, infinitybeachtest, infinitybeachclub, deepseabeachclub, atlantisbeachclub
    },
    outlet_id: {
      type: String,
      default: '' // process.env.VUE_APP_RESERVATION === 'development' ? '16981' : ''
    }
  },
  data: () => {
    return {
      // page: 'Home',
      isDevMode: process.env.VUE_APP_RESERVATION === 'development',
      currentPage: null,
      historyState: [],
    }
  },
  computed: {
    ...mapGetters(["getRouterData", "getLastRouterData", "getQueryRouter"]),
    isLoginPage() {
      return process.env.VUE_APP_RESERVATION === 'development' ? window.location.pathname?.includes('login') : false
    },
    getQueryPage() {
      return this.$store.getters.getQueryRouter.find(item => item.key === 'page')?.value
    },
    getAuthData() {
      return this.$store.getters.getAuthData
    },
  },
  watch: {
    store(payload) {
      if (payload.length) {
        console.log('store has arrived', payload)
      }
    },
    url_id(payload) {
      if (payload.length) {
        console.log('url_id has arrived', payload)
        this.$store.dispatch('checkDomain', payload)
      }
    },
    outlet_id(payload) {
      console.log('outlet_id has arrived', payload)
    },
    getAuthData(payload) {
      this.fetchDataStore(payload)
    },
  },
  mounted() {
    this.popStateHandler()
    this.$store.dispatch('checkDomain', this.url_id)
    const authData = JSON.parse(localStorage.getItem('olselforder_auth_data'))
    if (!authData) {
      Cookies.set('olselforder_url_domain', this.url_id)
      this.$store.dispatch('fetchToken', this.url_id)
    } else {
      this.fetchDataStore(authData)
    }

    const url = new URL(window.location.href);
    const currentParams = new URLSearchParams(url.search);
    let history = [];
    for (const [key, value] of currentParams) {
      history.push({
        key,
        value
      });
      if (key === 'page') {
        this.currentPage = value
      }
    }
    this.$store.dispatch('set_query_router', history)
    // console.log('localstorage:', localStorage.getItem('olselforder_selected_outlet'))
    if (process.env.VUE_APP_RESERVATION === 'development') {
      const mainContainer = document.querySelector('.app-main-container')
      mainContainer.style.marginTop = '60px'
    }
    // this.validateAuth()
  },
  methods: {
    popStateHandler() {
      return popStateHandler({
        getter: this.$store.getters
      })
    },
    fetchDataStore(payload) {
      const auth_data = payload // ? typeof payload === 'string' ? JSON.parse(payload) : payload : {}
      console.log('olselforder_auth_data', auth_data)
      const outletId = localStorage.getItem('olselforder_selected_outlet')
      console.log('outletId', outletId?.id)

      console.log('outlet_id', this.outlet_id)
      if (!outletId || this.outlet_id === '') {
        this.$store.dispatch('fetchStore', {
          outlet_id: this.outlet_id,
          domain_id: this.url_id
        })
      } else {
        this.$store.dispatch('fetchStoreOutlet', {
          outlet_id: outletId?.id || this.outlet_id,
          domain_id: this.url_id
        })
      }
      if (auth_data?.auth_by === 'BASIC' || auth_data?.auth_by === 'GUEST') {
        console.log('fetchCustomerData')
        this.fetchCustomerData(true)
      }
    },
    async fetchCustomerData(isAuth) {
      if (isAuth) {
        try {
          const { data } = await customerData().then(res => res.data)
          this.$store.dispatch('saveCustomerData', data)
        } catch (error) {
          console.log('error fetchCustomerData', error)
          this.$store.state.show_error = true
          this.$store.state.error_message = error.data.error
          this.$store.state.error_type = error.data.status_code
        } finally {
          this.$store.state.loading_axios = false
        }
      }
    },
  }
};
</script>

<style lang="css">
@import 'https://cdnjs.cloudflare.com/ajax/libs/vuetify/2.1.7/vuetify.css';
@import 'https://cdnjs.cloudflare.com/ajax/libs/vuetify/2.1.7/vuetify.css.map';
@import 'vue-phone-number-input/dist/vue-phone-number-input.css';
@import "vuetify/dist/vuetify.min.css";
@import 'vue2-timepicker/dist/VueTimepicker.css';
@import '@/assets/css/app.css';
@import '@/assets/css/Home.css';
@import '@/assets/css/payment.css';
@import '@/assets/css/InputOtp.css';
@import '@/assets/css/Layouts.css';
@import '@/assets/css/atlantisbeachclub.css';
@import '@/assets/css/deepseabeachclub.css';
@import '@/assets/css/smooking-area.css';

/* @import '@/assets/css/PlaceReservation.css'; */
.v-application {
  background-color: #fff !important;
}

.btn-booking {
  padding-top: 10px;
}

.btn-booking button {
  width: 100%;
  border-radius: 50px;
}
</style>